module.exports = __webpack_public_path__ + "images/frontpage_eye@1x.png?e55af9bc";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/frontpage_eye@1x.png
// module id = 639
// module chunks = 7